import { Box, Typography } from '@material-ui/core';
import React, { FC, useCallback } from 'react';
import LinkButton from '@/se/components/LinkButton';

type UnauthorizedScreenProps = {
  description: string;
  logOut?: () => Promise<void>;
};

export const UnauthorizedScreen: FC<UnauthorizedScreenProps> = ({ description, logOut }) => {
  const onRefreshClicked = useCallback(() => window.location.reload(), []);
  const onClearSessionClicked = useCallback(async () => {
    if (logOut) {
      await logOut();
    }
    window.location.reload();
  }, [logOut]);

  return (
    <Box flex={1} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <Typography variant="h4" component="h1" gutterBottom>
        {description}
      </Typography>
      <LinkButton onClick={onRefreshClicked}>Refresh</LinkButton>
      <LinkButton onClick={onClearSessionClicked}>Clear session and Refresh</LinkButton>
    </Box>
  );
};
